export default {"src":"/_next/static/media/volume.65ee068e.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};